import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Subscriptions icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Subscriptions } from '@sravni/design-system-icons'
 *
 * <Subscriptions />
 * ```
 */
var Subscriptions = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Subscriptions", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 9h2M7 17h2M12 17h5M19 4a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2M7 13h2M12 13h5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 3H8a1 1 0 0 0-1 1v5l2-1 2 1V4a1 1 0 0 0-1-1ZM5 4h2M11 4h8", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Subscriptions };
//# sourceMappingURL=Subscriptions.js.map
